import React, { useState, useEffect, useRef,useMemo } from 'react'
import { Line } from 'react-chartjs-2';
import { useSelector, useDispatch } from "react-redux";
import moment from 'moment'

function WearablesChart({chartData, healthType, unit}) {
    const dispatch = useDispatch();    
    const [intervals, setIntervals] = useState("");
    console.log(chartData,"chartData")

    const r = ~~(100 * Math.random() - 25)
    //memoize the colors
    const borderColor = useMemo(()=>`hsla(${213-r}, 100%, 60%,0.8)`,[])
    const backgroundColor = useMemo(()=>`hsla(${213-r}, 100%, 60%,0.4)`,[])

    useEffect(()=>{
        if (chartData?.length > 0) {
            let xAxisIntervals = splitDateIntoEqualIntervals(new Date(chartData[0].date?.split(' ').join('T')), new Date(chartData[chartData.length - 1].date.split(' ').join('T')), 5);
            if (xAxisIntervals){
                setIntervals(xAxisIntervals);
            }
        }
    },[chartData])
    
    function splitDateIntoEqualIntervals(startDate, endDate, numberOfIntervals){

        let diff =  endDate.getTime() - startDate.getTime();     
        let intervalLength = diff/numberOfIntervals;
        let intervals = [startDate];
        for(let i = 1 ; i <= numberOfIntervals;i++)
          intervals.push(new Date(startDate.getTime()+i*intervalLength))

        if (startDate != endDate) intervals.push(endDate);
        return intervals;
       
       }

            
    const data = {
        labels: intervals,
        datasets: [
            {
                label: `${unit} ${healthType}`,
                data: chartData?.map(record=>({x: moment(record.date.split(' ').join('T')).format("MMM DD, YYYY"), y: record.value})),
                fill: false,
                backgroundColor,
                borderColor,
            },
        ],
    };

    const options = {
        maintainAspectRatio: false,
        elements: {
            line: {
                tension: 0
            }
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }],
         xAxes: [{
          type: 'time',
          time: {
            unit: 'day',
            round:'day',
            displayFormats: {
              'day': 'MM/DD/YYYY'
            }
          },
        ticks :{
            source: "labels",
           
        },
        
       }]
    }}

    return (
        <>
            <div >
                <div className='text-center' style={{textTransform:"capitalize", fontSize:"1.2rem"}}> <i> {healthType} </i></div>
            </div>
            <div className="m-auto" style={{position: "relative", maxHeight:"300px", height:"40vh", width:"80vw"}}>
                <Line data={data} options={options} />
            </div>
        </>
    )

}

export default WearablesChart;